import { Button } from '~/components/form/SubmitButton';

interface FinishStepProps {
  onFinish: () => void;
  showButton: boolean;
  isSubmitting?: boolean;
}

export function FinishStep({
  onFinish,
  showButton,
  isSubmitting = false,
}: FinishStepProps) {
  if (!showButton) return null;

  return (
    <div className='flex justify-end'>
      <Button
        type='button'
        onClick={onFinish}
        disabled={isSubmitting}
        loading={isSubmitting}
        loadingText='Finishing setup...'
      >
        See my Jobs
      </Button>
    </div>
  );
}
